import { createAsyncThunk } from "@reduxjs/toolkit";
import { PostToBackoffice } from "../../utils/commands";
import { FetchFromUtilsConnect } from "../../utils/request";

type CommandResponse = { message?: string };

export type TargetSoftwareResponse = {
  serialId: string;
  targetSoftwareVersion: string;
};

export type SoftwareVersionRow = {
  version: string;
  isDefault: boolean;
};

export type SetTargetSoftwareVersionArg = {
  serialNumber: string;
  deviceId: string;
  version: string;
};

export const setTargetSoftwareVersion = createAsyncThunk(
  "targetSoftware/setVersion",
  async (arg: SetTargetSoftwareVersionArg, { rejectWithValue }) => {
    // API field `id` is the machine serial, not a separate id type.
    const res = (await PostToBackoffice("cmd/machine/set-sw-version", {
      id: arg.serialNumber,
      deviceId: arg.deviceId,
      version: arg.version,
    })) as CommandResponse;

    if (res.message && res.message.includes("failed")) {
      return rejectWithValue(res.message);
    }

    return { serialNumber: arg.serialNumber, version: arg.version };
  },
);

export const fetchAllSoftwareVersions = createAsyncThunk(
  "targetSoftware/fetchAllVersions",
  async () => {
    const data = await FetchFromUtilsConnect<SoftwareVersionRow[]>(
      "software/AllSofwareVersions",
    );
    return { list: data };
  },
);

export const fetchTargetSoftware = createAsyncThunk(
  "targetSoftware/fetch",
  async (serialId: string) => {
    const data = await FetchFromUtilsConnect<TargetSoftwareResponse>(
      `software/${serialId}/targetSoftWare`,
    );
    return {
      serialId,
      version: data?.targetSoftwareVersion,
    };
  },
);
